import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule,UrlModule, } from '@spartacus/core';
import { FormErrorsModule, IconModule, ItemCounterModule, KeyboardFocusModule, MediaModule, PageComponentModule, PageLayoutModule, PageSlotModule } from '@spartacus/storefront';

import { KnBrCartPageOptionsComponent } from './kn-br-cart-page-options.component';
import { CwtCartProductsComponent } from './cwt-cart-products/cwt-cart-products.component';
import { CwtCartOrderSummaryComponent } from './cwt-cart-order-summary/cwt-cart-order-summary.component';
import { CwtCartItemListComponent } from './cwt-cart-item-list/cwt-cart-item-list.component';
import { CwtCartItemRowComponent } from './cwt-cart-item-row/cwt-cart-item-row.component';
import { CwtCartItemCounterComponent } from './cwt-cart-item-counter/cwt-cart-item-counter.component';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import { CwtEmptyCartComponentComponent } from './cwt-empty-cart-component/cwt-empty-cart-component.component';
import { CartPageModalComponent } from './cart-page-modal/cart-page-modal.component';
import { CwtSpinnerModule } from 'src/app/common/cwt-spinner/cwt-spinner.module';
import { KnBrDirectiveModule } from 'src/app/shared/directive/kn-br-directive.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        I18nModule,
        FormErrorsModule,
        NgSelectModule,
        NgbTooltipModule,
        PageComponentModule,
        PageLayoutModule,
        PageSlotModule,
        MediaModule,
        KeyboardFocusModule,
        AddToCartModule,
        ItemCounterModule,
        IconModule,
        UrlModule,
        CwtSpinnerModule,
        KnBrDirectiveModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CwtCartPickupAndDeliveryComponent: {
                    component: KnBrCartPageOptionsComponent,
                },
                CwtProductDetailsComponent: {
                    component: CwtCartProductsComponent
                },
                CwtCartOrderSummaryComponent: {
                    component: CwtCartOrderSummaryComponent
                },
                CwtEmptyCartComponent: {
                    component: CwtEmptyCartComponentComponent
                }
            },
        } as CmsConfig),
        KnBrCartPageOptionsComponent, CwtCartProductsComponent, CwtCartOrderSummaryComponent, CwtCartItemListComponent, CwtCartItemRowComponent, CwtCartItemCounterComponent, CwtEmptyCartComponentComponent, CartPageModalComponent,
    ],
    exports: [KnBrCartPageOptionsComponent, CwtCartOrderSummaryComponent, CwtEmptyCartComponentComponent],
})
export class KnBrCartPageOptionsComponentModule { }
